<template>
  <div>
    <mdb-modal :show="$attrs.showModal" @close="close" size="lg">
      <mdb-modal-header>
        <mdb-modal-title>
          <slot name="header">default header</slot>
        </mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <slot name="body">default body</slot>
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn color="primary" @click.native="close">Close</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
import {
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbBtn
} from "mdbvue";

export default {
  name: "Modal",
  components: {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn
  },
  methods: {
    close() {
      this.$emit('close');
    },
  }
};
</script>